<template>
  <div :class="['box-admin mes-client-wrapper', wrapclass]">
    <blocHeaderTitle
      :titre="titre"
      sous-titre="Mes clients"
      :icone="['fas', 'user-tie']"
    >
      <b-button to="/dashboard/create-client" variant="outline-primary"
        ><font-awesome-icon :icon="['fas', 'user-plus']" />Nouveau
        Client</b-button
      >
    </blocHeaderTitle>

    <fieldset>
      <div class="listing-client-wrapper">
        <transition-group name="fade" tag="div" class="tasks__list">
          <bloc-type-client
            :client-id="'' + client.id"
            img-name="default-user.png"
            :client-name="client.nom"
            v-for="client in clients"
            :key="client.id"
            @delete="handleDeleteClient"
          ></bloc-type-client>
        </transition-group>
      </div>
    </fieldset>
    <!-- confirmation modal -->
    <b-modal
      id="modal-confirmation"
      title="Confirmation"
      ref="confirmationModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @ok="handleOk()"
      :modal-class="'base-modal'"
      cancel-variant="outline-primary"
      cancel-title="Annuler"
    >
      <p>Souhaitez-vous supprimer définitivement ce client ?</p>
    </b-modal>
    <!-- /confirmation modal -->
  </div>
</template>
<script>
import blocHeaderTitle from '../../components/utils/blocHeaderTitle'
import blocTypeClient from '../../components/utils/blocTypeClient'
import { mapActions } from 'vuex'
export default {
  components: {
    blocHeaderTitle,
    blocTypeClient
  },
  props: {
    titre: {
      type: String
    },
    wrapclass: {
      type: String
    }
  },
  data () {
    return {
      page: 0,
      clients: {},
      idClient: 0
    }
  },
  mounted () {
    this.getClientsList()
  },
  methods: {
    ...mapActions(['getClients', 'deleteClient']),
    getClientsList () {
      this.getClients(this.page).then((resp) => {
        this.clients = resp.items
      })
    },
    handleDeleteClient (id) {
      this.idClient = id
      this.$refs.confirmationModal.show()
    },
    handleOk () {
      this.deleteClient(this.idClient).then(async (res) => {
        this.clients.splice(this.clients.findIndex(x => x.id === parseInt(this.idClient, 10)), 1)
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/listingClientEditeur/index.vue